import React from "react";
import { connect } from "react-redux";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import EquipmentCard from "./EquipmentCard";
import DatePicker from "react-datepicker";
import Moment from "moment";
import { Card } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import * as moment from "moment";
import ChartDataLabels from "chartjs-plugin-datalabels";
import "react-datepicker/dist/react-datepicker.css";
import { AutoComplete } from "primereact/autocomplete";
import Autocomplete from "react-autocomplete";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import { media } from "glamor";
import ReactDOM from 'react-dom';
import {
  getShipsCount,
  getShipDeatil,
  getShipEquipmentSearchlist,
  downloadServiceRequest,
} from "../Actions/ShipEquipmentDetailsAPI";
import { getShipEquipmentAndCategoryList } from "../Actions/helpersAPI";
import {
  DownloadAttachment,
  DownloadFirePlanAttachment,
} from "../Actions/AttachmentAPI";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
// import { faker } from "@faker-js/faker";
import axios from "axios";
import $ from "jquery";
import API from "../helpers/api";
import { Multiselect } from "multiselect-react-dropdown";
import { getServiceTypeList } from "../Actions/CommonAPI";
import { downloadShipEquipmentStatus } from "../Actions/ShipEquipmentDetailsAPI";
// import { Button, Popover, PopoverHeader, PopoverBody } from "reactstrap";
import note from "../Asset/note_svg.svg";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";

import Role from "../helpers/role";
import i18n from "./DropdownLanguage/i18n";
import { toast } from "react-toastify";

let userrole = localStorage.getItem("UserRoles");
let currentUser = JSON.parse(localStorage.getItem("currentUser"));

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const SearchShipItem = {
  equipment: "",
  next_due_in_from: "",
  next_due_in_to: "",
  pagesize: 25,
  status: "",
  pagenumber: 1,
  ServiceTypes: [],
  shipId: "",
  isTotalShips: true,
  isOverdueShips: false,
  isShipsDue30: false,
  isShipsDue90: false,
};

let data;
let options;

class ShipLibrary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFile: false,
      GraphListView: [],
      isGrandAdmin: false,
      SelectedFromDate: "",
      SelectedToDate: "",
      fromDate: "",
      toDate: "",
      totalEquipments: 100,
      totalExpiredEquipments: 99,
      totalExpiringEquipments: 100,
      fromDatePickerIsOpen: false,
      toDatePickerIsOpen: false,
      getItem: {
        EquipmentName: "",
        Category: "",
        shipId: "",
      },
      searchEquipment: {
        equipment: "",
        category: "",
        next_due_in_from: "",
        next_due_in_to: "",
        pagesize: 25,
        pagenumber: 1,
        ServiceTypes: [],
        status: "",
        shipId: "",
        isTotalShips: true,
        isOverdueShips: false,
        isShipsDue10: false,
        isShipsDue30: false,
        isShipsDue60: false,
        isShipsDue90: false,
      },
      _ClassData: [],
      _MakeModelData: [],
      _FlagData: [],
      temp: [],
      EquipmentList: ["A_Equipment1", "B_Equipment2", "C_Equipment"],
      EquipmentName: "",
      serviceType: [],
      EditAll: false,
      isShip: false,
      isShore: false,
      isBoth: false,
      inContract: false,
      notInContract: false,
      isBothContract: true,
    };

    this.multiSelectRef = React.createRef()
    this.onSelectChange = this.onSelectChange.bind(this);
    this.onRemoveChange = this.onRemoveChange.bind(this);
    this.handleFromDateChange = this.handleFromDateChange.bind(this);
    this.handleToDateChange = this.handleToDateChange.bind(this);
    this.openFromDatePicker = this.openFromDatePicker.bind(this);
    this.openToDatePicker = this.openToDatePicker.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.SearchEquipmentData = this.SearchEquipmentData.bind(this);
  }

  async componentDidMount() {
    console.log(window.location.pathname, 'tt')
    const { dispatch, match, EditShipDetails, IsServiceUpdate, history, t } = this.props;
    const { searchEquipment, getItem, previousUrl } = this.state;
    const Id = match.params.id;
    if ((window.location.pathname).includes('Home/ServiceShipDetails')) {
      this.props.dispatch({ type: "EditShipDetails", data: true });
      this.props.dispatch({ type: "IsServiceUpdate", data: true });
    }
    console.log(EditShipDetails, IsServiceUpdate, 'test')
    const currentPath = window.location.pathname;
    if (currentPath.startsWith("/Home/ServiceShipDetails/")) {
      dispatch({ type: "SubBannerTitle", data: "Service Update" })
    }
    else if (currentPath.startsWith("/Home/ShipDetails/")) {
      dispatch({ type: "SubBannerTitle", data: "Ship Equipment Status" })
    }
    else if (currentPath.startsWith("/Home/PendingShipDetails/")) {
      dispatch({ type: "SubBannerTitle", data: "Pending Ship Dashboard" })
    }
    // this.unlisten = history.listen(location => {
    //   const currentUrlFOrtitle = location.pathname;
    //   localStorage.setItem('previousUrl', currentUrlFOrtitle);
    //   this.setState({ previousUrl: location.pathname });
    // });
    // const storedPreviousUrl = localStorage.getItem('previousUrl');
    // if (storedPreviousUrl) {
    //   if (storedPreviousUrl.includes("Home/MMPLDashboard")) {
    //     dispatch({ type: "SubBannerTitle", data: "Ship Equipment Status" })
    //   } else if (storedPreviousUrl.includes("Home/ServiceUpdate")) {
    //     dispatch({ type: "SubBannerTitle", data: "Service Update" })
    //   }
    //   else if (storedPreviousUrl.startsWith("Home/") && storedPreviousUrl.endsWith("/Notes")) {
    //     console.log("Matched /Home/:shipid/Notes");
    //     dispatch({ type: "SubBannerTitle", data: "Ship Equipment Status" });
    //   }
    // }

    // this.props.dispatch({ type: "ShowEquipmentDetails", data: false });
    //dispatch({ type: "EditEquipmentDetails", data: false });
    let BothResult = localStorage.getItem("SearchBothContract");
    let ContractResult = localStorage.getItem("SearchCotract");
    if (BothResult) {
      this.state.isBothContract = JSON.parse(BothResult);
    }
    if (ContractResult) {
      this.state.inContract = JSON.parse(ContractResult);
    }
    this.setState({})
    if (match.params.id) {
      searchEquipment.shipId = match.params.id;
      getItem.shipId = match.params.id;
      let pageNo;
      if (this.props.MDSearchData) {
        pageNo = this.props.MDSearchData.pagenumber;
      }
      console.log(this.props.MDSearchData);
      this.setState({ searchEquipment: searchEquipment });
      dispatch(getShipEquipmentAndCategoryList(getItem));
      this.getShipsCount(match.params.id, this.state.inContract, this.state.isBothContract, pageNo ?? 1)

    } else {
      this.getStaffShipDetail(1);
    }
    this.getuserDetails(currentUser.email);

    //this.getGrapinfo(Id);
    let searchData = this.state.searchEquipment;
    let _this = this;
    this.keyPressHandler = function (event) {
      var keycode = event.keyCode || event.which;

      if (keycode === 13) {
        if (
          searchData.equipment ||
          searchData.category ||
          searchData.ServiceTypes.length > 0 ||
          searchData.next_due_in_from ||
          searchData.next_due_in_to
        ) {
          _this.SearchEquipmentData(1);
        }
        else {
          toast.success(t('Toast.Success'), {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      }
    }

    $(document).keypress(this.keyPressHandler);
    // this.ClearShipSearchField();
  }

  componentWillUnmount() {

    $(document).off("keypress", this.keyPressHandler);
  }

  // componentWillUnmount() {
  //   if (this.unlisten) {
  //     this.unlisten();
  //   }
  // }
  getShipsCount = (shipId, contract, both, pageNO) => {
    const { dispatch, match } = this.props;
    let url = "";
    if (userrole === "staff") {
      url = `${API.ShipEquipmentCount + shipId}&mail=${currentUser.email}&inContract=${contract}&isBoth=${both}`;
    } else {
      url = `${API.ShipEquipmentCount + shipId}&inContract=${contract}&isBoth=${both}`;
    }
    axios
      .get(url)
      .then((response) => {

        if (response.status === 200) {
          dispatch({
            type: "GetShipEquipmentCountSuccess",
            data: response.data,
          })
          this.getShipStatus(match.params.id, pageNO);
        }
      })
      .catch((error) => {
        dispatch({
          type: "GetShipEquipmentCountFailure",
          error: "ERROR",
        });
      });

  };

  getuserDetails(mailId) {
    const { dispatch } = this.props;
    let url = `${API.getUser}?Mail=${mailId}`;
    axios
      .get(url)
      .then((response) => {
        if (response?.data?.data) {
          let id = response?.data?.data[0].userId;
          let url1 = `${API.getUserDetail}?userid=${id}`;
          axios
            .get(url1)
            .then((response1) => {
              if (response1 && response1.data) {
                console.log("response1.data", response1.data);
                this.setState({
                  isGrandAdmin: response1.data?.grandAdminAccess,
                });
                dispatch(getServiceTypeList());
              }
            })
            .catch((error) => { });
        }
      })
      .catch((error) => { });
  }
  getShipStatus = (shipId, pageNo) => {
    var Id = parseInt(shipId);
    const { dispatch } = this.props;
    let user = JSON.parse(localStorage.getItem("currentUser"));
    let url = `${API.ShipDetail}?shipId=${Id}`;
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetShipDetailSuccess",
          data: response.data,
        });
        this.state.searchEquipment.status = response.data.status;
        this.state.searchEquipment.shipId = Id;
        this.setState({ searchEquipment: this.state.searchEquipment }, () => {
          this.SearchEquipmentData(pageNo);
        });
      })
      .catch((error) => {
        dispatch({
          type: "GetShipDetailFailure",
          error: "ERROR",
        });
      });
  };
  getStaffShipDetail = () => {
    const { dispatch } = this.props;
    let user = JSON.parse(localStorage.getItem("currentUser"));
    if (user.email) {
      let url = `${API.ShipDetail}?Mail=${user.email}`;
      axios
        .get(url)
        .then((response) => {
          this.state.getItem.shipId = response.data.shipId;
          dispatch(getShipsCount(response.data.shipId, this.state.inContract, this.state.isBothContract));
          dispatch({ type: "GetShipDetailSuccess", data: response.data });
          dispatch({ type: "StaffShipId", data: response.data.shipId });
          dispatch(getShipEquipmentAndCategoryList(this.state.getItem));
          this.state.searchEquipment.shipId = response.data.shipId;
          this.state.searchEquipment.status = response.data.status;
          this.setState({ searchEquipment: this.state.searchEquipment }, () => {
            this.SearchEquipmentData(1);
          });
        })
        .catch((error) => {
          dispatch({
            type: "GetShipDetailFailure",
            error: "ERROR",
          });
        });
    }
  };

  toggleVisibiliti = () => {
    this.setState((prevState) => ({ isFile: !this.state.isFile }));
  };

  getShipDetails(action, isShipService = false, isShoreService = false) {
    const { dispatch } = this.props;
    if (action === 1) {
      this.state.filterTitle = "All Ships";
      this.state.searchEquipment.isTotalShips = true;
      this.state.searchEquipment.isOverdueShips = false;
      this.state.searchEquipment.isShipsDue30 = false;
      this.state.searchEquipment.isShipsDue90 = false;
      this.state.searchEquipment.isShipsDue10 = false;
      this.state.searchEquipment.isShipsDue60 = false;
      this.setState({}, () => {
        this.SearchEquipmentData(1);
        this.ClearShipSearchField("clearClick");
      });
    } else if (action === 2) {
      this.state.filterTitle = "Overdue Ships";
      this.state.searchEquipment.isTotalShips = false;
      this.state.searchEquipment.isOverdueShips = true;
      this.state.searchEquipment.isShipsDue30 = false;
      this.state.searchEquipment.isShipsDue90 = false;
      this.state.searchEquipment.isShipsDue10 = false;
      this.state.searchEquipment.isShipsDue60 = false;
      this.state.searchEquipment.isShipService = isShipService;
      this.state.searchEquipment.isShoreService = isShoreService;
      this.setState({}, () => {
        this.SearchEquipmentData(1);
        this.ClearShipSearchField("clearClick");
      });
    } else if (action === 3) {
      this.state.filterTitle = "Overdue Ships 30";
      this.state.searchEquipment.isTotalShips = false;
      this.state.searchEquipment.isOverdueShips = false;
      this.state.searchEquipment.isShipsDue30 = true;
      this.state.searchEquipment.isShipsDue90 = false;
      this.state.searchEquipment.isShipsDue10 = false;
      this.state.searchEquipment.isShipsDue60 = false;
      this.state.searchEquipment.isShipService = isShipService;
      this.state.searchEquipment.isShoreService = isShoreService;
      this.setState({}, () => {
        this.SearchEquipmentData(1);
        this.ClearShipSearchField("clearClick");
      });
    } else if (action === 4) {
      this.state.filterTitle = "Overdue Ships 90";
      this.state.searchEquipment.isTotalShips = false;
      this.state.searchEquipment.isOverdueShips = false;
      this.state.searchEquipment.isShipsDue30 = false;
      this.state.searchEquipment.isShipsDue90 = true;
      this.state.searchEquipment.isShipsDue10 = false;
      this.state.searchEquipment.isShipsDue60 = false;
      this.state.searchEquipment.isShipService = isShipService;
      this.state.searchEquipment.isShoreService = isShoreService;
      this.setState({}, () => {
        this.SearchEquipmentData(1);
        this.ClearShipSearchField("clearClick");
      });
    } else if (action === 5) {
      this.state.filterTitle = "Overdue Ships 10";
      this.state.searchEquipment.isTotalShips = false;
      this.state.searchEquipment.isOverdueShips = false;
      this.state.searchEquipment.isShipsDue30 = false;
      this.state.searchEquipment.isShipsDue90 = false;
      this.state.searchEquipment.isShipsDue10 = true;
      this.state.searchEquipment.isShipsDue60 = false;
      this.state.searchEquipment.isShipService = isShipService;
      this.state.searchEquipment.isShoreService = isShoreService;
      this.setState({}, () => {
        this.SearchEquipmentData(1);
        this.ClearShipSearchField("clearClick");
      });
    } else if (action === 6) {
      this.state.filterTitle = "Overdue Ships 60";
      this.state.searchEquipment.isTotalShips = false;
      this.state.searchEquipment.isOverdueShips = false;
      this.state.searchEquipment.isShipsDue30 = false;
      this.state.searchEquipment.isShipsDue90 = false;
      this.state.searchEquipment.isShipsDue10 = false;
      this.state.searchEquipment.isShipsDue60 = true;
      this.state.searchEquipment.isShipService = isShipService;
      this.state.searchEquipment.isShoreService = isShoreService;
      this.setState({}, () => {
        this.SearchEquipmentData(1);
        this.ClearShipSearchField("clearClick");
      });
    }
  }

  hideSidePanel() {

    const { match } = this.props;
    this.props.dispatch({ type: "ShowEquipmentDetails", data: false });
    if (match.path === "/Home/PendingShipDetails/:id") {
      this.props.dispatch({ type: "Pendingsearched", data: true });
      this.props.dispatch({ type: "ShowEquipmentDetails", data: false });
      // this.props.history.goBack();
      this.props.history.push("/Home/PendingShip");

    }
    else if (match.path === "/Home/ServiceShipDetails/:id") {
      this.props.history.goBack()
    }
    else {
      this.props.dispatch({ type: "searched", data: true });
      this.props.dispatch({ type: "MapPopup", data: 0 });
      this.props.dispatch({ type: "ShowEquipmentDetails", data: false });
      // this.props.history.goBack();
      this.props.history.push("/Home/MMPLDashboard");
    }
  }

  getGrapinfo = (shipId) => {
    let Id = parseInt(shipId);
    let apiUrl = API.getGraphList + "?shipId=" + Id;
    axios({
      method: "get",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          this.state.GraphListView = response.data;
        }
        this.setState({}, () => {
          this.bindData(this.state.GraphListView);
        });
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        if (error?.response?.status === 401) {
        }
      });
  };
  bindData = () => {
    this.state.GraphListView.map((i, ind) => {
      var item = i.yearly;
      this.state.temp.push(item);
      this.setState({});
    });
    this.state.temp.map((i, index) => {
      var temp1 = this.state.GraphListView.filter((x) => x.yearly == i);
      this.state._ClassData.push(temp1[0].class);
      this.state._FlagData.push(temp1[0].flag);
      this.state._MakeModelData.push(temp1[0].makeandModel);
      this.setState({});
    });
    console.log(
      "resultvalue",
      this.state._ClassData,
      this.state._FlagData,
      this.state._MakeModelData,
      this.state.temp
    );
  };
  static getDerivedStateFromProps(nextProps, prevState) {
    const { dispatch } = nextProps;
    if (nextProps.isMDSearch) {
      prevState.searchEquipment = nextProps.MDSearchData;
    }
    if (nextProps.MDDeleteSuccess) {
      prevState.searchEquipment = nextProps.MDSearchData;
      //dispatch(getShipEquipmentSearchlist(prevState.searchEquipment));
    }
  }

  SearchEquipmentData(pgno) {
    const { dispatch } = this.props;
    this.state.searchEquipment.pagenumber = pgno;
    // if (match.params.id) {
    //   this.state.searchEquipment.shipId = match.params.id;
    // }
    dispatch(getShipEquipmentSearchlist(this.state.searchEquipment, this.state.inContract, this.state.isBothContract));
  }

  ClearShipSearchField = (type) => {

    // this.setState({
    //   searchEquipment:{
    //     ...this.state.searchEquipment,
    //     pagenumber:1
    //   }
    // })
    const { dispatch } = this.props;
    this.multiSelectRef.current.resetSelectedValues()
    let param = { ...SearchShipItem };
    this.state.searchEquipment.equipment = "";
    this.state.searchEquipment.category = "";
    this.state.searchEquipment.status = this.state.searchEquipment.status;
    this.state.searchEquipment.next_due_in_from = "";
    this.state.searchEquipment.next_due_in_to = "";
    this.state.getItem.Category = "";
    this.state.getItem.EquipmentName = "";
    this.state.searchEquipment.ServiceTypes = [];
    this.state.searchEquipment.pagenumber = 1;

    dispatch(getShipEquipmentAndCategoryList(this.state.getItem));
    this.setState(
      {
        searchEquipment: param,
        serviceType: [],
      },
      () => {
        if (type != "clearClick")
          dispatch(getShipEquipmentSearchlist(this.state.searchEquipment, this.state.inContract, this.state.isBothContract));
      }
    );
  };

  handleFromDateChange(date) {
    this.state.searchEquipment.next_due_in_from = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      SelectedFromDate: date,
      fromDatePickerIsOpen: false,
    });
  }

  handleToDateChange(date) {
    this.state.searchEquipment.next_due_in_to = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      SelectedToDate: date,
      toDatePickerIsOpen: false,
    });
  }

  openFromDatePicker() {
    this.setState({
      toDatePickerIsOpen: false,
      fromDatePickerIsOpen: !this.state.fromDatePickerIsOpen,
    });
  }

  openToDatePicker() {
    this.setState({
      fromDatePickerIsOpen: false,
      toDatePickerIsOpen: !this.state.toDatePickerIsOpen,
    });
  }

  handleBlur() {
    this.setState({
      toDatePickerIsOpen: false,
      fromDatePickerIsOpen: false,
    });
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state.searchEquipment[nodeName] = e.target.value;
    this.setState({});
  }
  handleInputChanges = (e, name, subName) => {
    this.state.searchEquipment[name] = e.target.value;
    this.state.getItem[subName] = e.target.value;
    if (this.state.getItem[subName] === "") {
      this.props.dispatch(getShipEquipmentAndCategoryList(this.state.getItem));
    }
    this.setState({});
  };
  handleSelectChange = (e, name, id, subName) => {
    this.state.searchEquipment[name] = e;
    this.state.getItem[subName] = e;
    this.props.dispatch(getShipEquipmentAndCategoryList(this.state.getItem));
    this.setState({});
  };
  renderEquipmentTitle = (state, val) => {
    return (
      state?.equipmentName?.toLowerCase().indexOf(val?.toLowerCase()) !== -1
    );
  };
  renderCategoryTitle = (state, val) => {
    return state?.category?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
  };
  suggestMItable(event) {
    let results = this.state.EquipmentList.filter((table) => {
      return table.toLowerCase().indexOf(event.query.toLowerCase()) > -1;
    });

    this.setState({ EquipmentList: results });
  }

  checkBoxClick(item, e) {
    let checked = [];
    checked = this.state.serviceType;
    if (e.target.checked) {
      checked.push({
        checkboxValue: item,
      });
      if (item === "Annual") {
        this.state.searchEquipment.Annually = true;
      } else if (item === "Biannual") {
        this.state.searchEquipment.Biannually = true;
      } else if (item === "Five yearly") {
        this.state.searchEquipment.FiveYearly = true;
      } else if (item === "Ten yearly") {
        this.state.searchEquipment.Tenyearly = true;
      }
    } else {
      const index = checked.findIndex((ch) => ch.checkboxValue === item);
      checked.splice(index, 1);
      if (item === "Annual") {
        this.state.searchEquipment.Annually = false;
      } else if (item === "Biannual") {
        this.state.searchEquipment.Biannually = false;
      } else if (item === "Five yearly") {
        this.state.searchEquipment.FiveYearly = false;
      } else if (item === "Ten yearly") {
        this.state.searchEquipment.Tenyearly = false;
      }
    }
    this.setState({ serviceType: checked });
    this.setState({});
  }

  onSelectChange(item) {
    this.state.searchEquipment.ServiceTypes = item;
    this.setState({});
  }

  onRemoveChange(item) {
    this.state.searchEquipment.ServiceTypes = item;
    this.setState({});
  }

  downloadStatus = (item) => {
    const { dispatch } = this.props;
    dispatch(downloadShipEquipmentStatus(item.shipId, item.shipName));
  };

  toggle = () => {
    this.setState({
      EditAll: !this.state.EditAll,
      ship: false,
      shore: false,
      both: false,
    });
  };

  handleRadioButtonChange = (e) => {
    let nodeName = e.target.name;
    if (nodeName === "ship") {
      this.state.isShip = true;
      this.state.isShore = false;
      this.state.isBoth = false;
    }
    if (nodeName === "shore") {
      this.state.isShip = false;
      this.state.isShore = true;
      this.state.isBoth = false;
    }
    if (nodeName === "both") {
      this.state.isShip = false;
      this.state.isShore = false;
      this.state.isBoth = true;
    }
    this.setState({});
  };

  submitRequest = (item) => {
    const { dispatch } = this.props;
    dispatch(downloadServiceRequest(item, this.state));
  };

  ViewNotes(item) {
    console.log("shipinfo", item);
    const { history, dispatch } = this.props;
    history.push(`/Home/${item.shipId}/Notes`);
    dispatch({ type: "ShipInfo", data: item });
  }
  renderPopover(props) {
    const { t } = this.props;
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label>{t("DashboardShipReports.ShipReports")}</label>
        </Popover.Content>
      </Popover>
    );
  }

  renderViewDetails(props) {
    const { t } = this.props;
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label>{t("CommonText.ViewAggrement")}</label>
        </Popover.Content>
      </Popover>
    );
  }
  renderDownloadDetails(props) {
    const { t } = this.props;
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label>{t("CommonText.DownloadAggrement")}</label>
        </Popover.Content>
      </Popover>
    );
  }
  renderfiredownload(props) {
    const { t } = this.props;
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label>{t("CommonText.Download")}</label>
        </Popover.Content>
      </Popover>
    );
  }
  render() {
    const {
      shipEquipmentCount,
      shipDetail,
      showEquipmentDetails,
      shipSearchResult,
      editShipDetailsPane,
      editEquipmentDetailsPane,
      serviceTypeList,
      EquipmentNameList,
      CategoryNameList,
      t
    } = this.props;
    const { serviceType, temp } = this.state;
    const {
      isTotalShips,
      isOverdueShips,
      isShipsDue10,
      isShipsDue30,
      isShipsDue60,
      isShipsDue90,
    } = this.state.searchEquipment;

    const data = {
      labels: temp,
      datasets: [
        {
          label: "Class",
          data: this.state?._ClassData,
          backgroundColor: "#ADD8E6",
          borderColor: "#ADD8E6",
        },
        {
          label: "Make & Model",
          data: this.state?._MakeModelData,
          backgroundColor: "rgba(255, 99, 132, 0.5)",
          borderColor: "rgba(255, 99, 132, 0.5)",
        },
        {
          label: "Flag",
          data: this.state?._FlagData,
          backgroundColor: "#000080",
          borderColor: "#000080",
        },
      ],
    };
    const options = {
      scales: {
        x: {
          stacked: false,
          grid: {
            display: false,
            drawBorder: false,
          },
          ticks: {
            color: "black",
            font: {
              size: 12,
              lineHeight: 1,
            },
          },
        },
        y: {
          min: 0,
          max: 100,
          ticks: {
            stepSize: 10,
          },
          stacked: false,
          display: false,
          grid: {
            display: false,
            drawBorder: false,
          },
        },
      },
      indexAxis: "x",
      elements: {
        bar: {
          borderWidth: 1,
          padding: 3,
        },
      },
      responsive: true,
      plugins: {
        legend: {
          position: "bottom",
          margin: 20,
        },
        datalabels: {
          anchor: "end",
          align: "top",
          font: {
            weight: "bold",
          },
        },
      },
    };

    const isArabic = i18n.language === 'arab'

    return (
      <div className="full-height pt-3">
        {window.location.pathname.indexOf("/Home/PendingShipDetails") !==
          -1 ? null : !editShipDetailsPane ? (
            <div className="row">
              <div className="col-lg-2">
                <div
                  className={`${isTotalShips ? "active " : ""
                    }card card-selector countcard mb2 p-2 text-center h-100 pointer-default`}

                >
                  <h1 className="pointer-cursor" onClick={() => this.getShipDetails(1, false, false)}>
                    {shipEquipmentCount.total ? shipEquipmentCount.total : 0}
                  </h1>
                  {showEquipmentDetails || editEquipmentDetailsPane ? (
                    <h6 className="text-center" style={{ paddingTop: '20px' }}>{t("ShipEquipmentStatusScreen.Total")}</h6>
                  ) : (
                    <h5 className="text-center" style={{ paddingTop: '20px' }}>{t("ShipEquipmentStatusScreen.Total")}</h5>
                  )}
                </div>
              </div>
              <div className="col-lg-2">
                <div
                  className={`${isOverdueShips ? "active " : ""
                    }card card-selector countcard mb2 p-2 text-center pointer-default ${showEquipmentDetails || editEquipmentDetailsPane ? "hei-153" : ''}`}

                >
                  <h3 style={{ color: "rgb(255, 0, 0)" }} className="pointer-cursor" onClick={() => this.getShipDetails(2, false, false)}>
                    {shipEquipmentCount.overDueCount?.total ? shipEquipmentCount.overDueCount?.total : 0}
                  </h3>
                  {showEquipmentDetails || editEquipmentDetailsPane ? (
                    <h6 className="text-center" style={{ fontSize: "small" }}>{t("ShipEquipmentStatusScreen.Overdue")}</h6>
                  ) : (
                    <h6 className="text-center">{t("ShipEquipmentStatusScreen.Overdue")}</h6>
                  )}
                  <div className={`row ${showEquipmentDetails || editEquipmentDetailsPane ? "" : "mt-2"}`}>
                    <div className={showEquipmentDetails || editEquipmentDetailsPane ? "col-12" : "col-6"} >
                      <h6 style={{ fontSize: showEquipmentDetails || editEquipmentDetailsPane ? 'small' : '' }} className={`text-nowrap pointer-cursor ${isArabic ? 'arabic' : ''}`} id={isArabic ? (showEquipmentDetails ? 'arabicMobile' : 'arabicId') : ''} onClick={() => this.getShipDetails(2, true, false)} >{t("content.ship")}{" "}
                        <span style={{ color: "rgb(255, 0, 0)" }}>
                          {" "}  {shipEquipmentCount.overDueCount?.ship ? shipEquipmentCount.overDueCount?.ship : 0}&nbsp;
                        </span>
                      </h6>
                    </div>
                    <div className={showEquipmentDetails || editEquipmentDetailsPane ? "col-12" : "col-6"}>
                      <h6 style={{ fontSize: showEquipmentDetails || editEquipmentDetailsPane ? 'small' : '' }} className={`text-nowrap pointer-cursor ${isArabic ? 'arabic' : ''}`} id={isArabic ? (showEquipmentDetails ? 'arabicMobile' : 'arabicId') : ''} onClick={() => this.getShipDetails(2, false, true)}>{t("content.shore")}{" "}
                        <span style={{ color: "rgb(255, 0, 0)" }}>
                          {shipEquipmentCount.overDueCount?.shore ? shipEquipmentCount.overDueCount?.shore : 0}&nbsp;
                        </span>
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-2">
                <div
                  className={`${isShipsDue10 ? "active " : ""
                    }card card-selector countcard mb2 p-2 text-center ${showEquipmentDetails || editEquipmentDetailsPane ? "hei-153" : ''} pointer-default`}

                >
                  <h3 style={{ color: "rgb(255, 130, 90)" }} onClick={() => this.getShipDetails(5, false, false)} className="pointer-cursor">
                    {shipEquipmentCount.in10DaysCount?.total
                      ? shipEquipmentCount.in10DaysCount?.total
                      : 0}
                  </h3>
                  {showEquipmentDetails || editEquipmentDetailsPane ? (
                    <h6 className="text-center" style={{ fontSize: "small" }}>{t("ShipEquipmentStatusScreen.Due10")}</h6>
                  ) : (
                    <h6 className="text-center"> {t("ShipEquipmentStatusScreen.Due10")}</h6>
                  )}
                  <div className={`row ${showEquipmentDetails || editEquipmentDetailsPane ? "" : "mt-2"}`}>
                    <div className={showEquipmentDetails || editEquipmentDetailsPane ? "col-12" : "col-6"}>
                      <h6 style={{ fontSize: showEquipmentDetails || editEquipmentDetailsPane ? 'small' : '' }} className={`text-nowrap pointer-cursor ${isArabic ? 'arabic' : ''}`} id={isArabic ? (showEquipmentDetails ? 'arabicMobile' : 'arabicId') : ''} onClick={() => this.getShipDetails(5, true, false)}>{t("content.ship")}{" "}
                        <span style={{ color: "rgb(255, 130, 90)" }}>
                          {shipEquipmentCount.in10DaysCount?.ship ? shipEquipmentCount.in10DaysCount?.ship : 0}&nbsp;
                        </span>
                      </h6>
                    </div>
                    <div className={showEquipmentDetails || editEquipmentDetailsPane ? "col-12" : "col-6"}>
                      <h6 style={{ fontSize: showEquipmentDetails || editEquipmentDetailsPane ? 'small' : '' }} className={`text-nowrap pointer-cursor ${isArabic ? 'arabic' : ''}`} id={isArabic ? (showEquipmentDetails ? 'arabicMobile' : 'arabicId') : ''} onClick={() => this.getShipDetails(5, false, true)}>{t("content.shore")}{" "}
                        <span style={{ color: "rgb(255, 130, 90)" }}>
                          {shipEquipmentCount.in10DaysCount?.shore ? shipEquipmentCount.in10DaysCount?.shore : 0}&nbsp;
                        </span>
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-2">
                <div
                  className={`${isShipsDue30 ? "active " : ""
                    }card card-selector countcard mb2 p-2 text-center ${showEquipmentDetails || editEquipmentDetailsPane ? "hei-153" : ''} pointer-default`}
                >
                  <h3 style={{ color: "rgb(255, 130, 90)" }} className="pointer-cursor" onClick={() => this.getShipDetails(3, false, false)}>
                    {shipEquipmentCount.in30DaysCount?.total
                      ? shipEquipmentCount.in30DaysCount?.total
                      : 0}
                  </h3>
                  {showEquipmentDetails || editEquipmentDetailsPane ? (
                    <h6 className="text-center" style={{ fontSize: "small" }}>{t("ShipEquipmentStatusScreen.Due30")}</h6>
                  ) : (
                    <h6 className="text-center">{t("ShipEquipmentStatusScreen.Due30")} </h6>
                  )}
                  <div className={`row ${showEquipmentDetails || editEquipmentDetailsPane ? "" : "mt-2"}`}>
                    <div className={showEquipmentDetails || editEquipmentDetailsPane ? "col-12" : "col-6"}>
                      <h6 style={{ fontSize: showEquipmentDetails || editEquipmentDetailsPane ? 'small' : '' }} className={`text-nowrap pointer-cursor ${isArabic ? 'arabic' : ''}`} id={isArabic ? (showEquipmentDetails ? 'arabicMobile' : 'arabicId') : ''} onClick={() => this.getShipDetails(3, true, false)}>{t("content.ship")}{" "}
                        <span style={{ color: "rgb(255, 130, 90)" }}>
                          {shipEquipmentCount.in30DaysCount?.ship ? shipEquipmentCount.in30DaysCount?.ship : 0}&nbsp;
                        </span>
                      </h6>
                    </div>
                    <div className={showEquipmentDetails || editEquipmentDetailsPane ? "col-12" : "col-6"}>
                      <h6 style={{ fontSize: showEquipmentDetails || editEquipmentDetailsPane ? 'small' : '' }} className={`text-nowrap pointer-cursor ${isArabic ? 'arabic' : ''}`} id={isArabic ? (showEquipmentDetails ? 'arabicMobile' : 'arabicId') : ''} onClick={() => this.getShipDetails(3, false, true)}>{t("content.shore")}{" "}
                        <span style={{ color: "rgb(255, 130, 90)" }}>
                          {shipEquipmentCount.in30DaysCount?.shore ? shipEquipmentCount.in30DaysCount?.shore : 0}&nbsp;
                        </span>
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-2">
                <div
                  className={`${isShipsDue60 ? "active " : ""
                    }card card-selector countcard mb2 p-2 text-center pointer-default ${showEquipmentDetails || editEquipmentDetailsPane ? "hei-153" : ''}`}

                >
                  <h3 style={{ color: "rgb(255, 130, 90)" }} className="pointer-cursor" onClick={() => this.getShipDetails(6, false, false)}>
                    {shipEquipmentCount.in60DaysCount?.total
                      ? shipEquipmentCount.in60DaysCount?.total
                      : 0}
                  </h3>
                  {showEquipmentDetails || editEquipmentDetailsPane ? (
                    <h6 className="text-center" style={{ fontSize: "small" }}>{t("ShipEquipmentStatusScreen.Due60")}</h6>
                  ) : (
                    <h6 className="text-center">{t("ShipEquipmentStatusScreen.Due60")}</h6>
                  )}
                  <div className={`row ${showEquipmentDetails || editEquipmentDetailsPane ? "" : "mt-2"}`}>
                    <div className={showEquipmentDetails || editEquipmentDetailsPane ? "col-12" : "col-6"}>
                      <h6 style={{ fontSize: showEquipmentDetails || editEquipmentDetailsPane ? 'small' : '' }} className={`text-nowrap pointer-cursor ${isArabic ? 'arabic' : ''}`} id={isArabic ? (showEquipmentDetails ? 'arabicMobile' : 'arabicId') : ''} onClick={() => this.getShipDetails(6, true, false)}>{t("content.ship")}{" "}
                        <span style={{ color: "rgb(255, 130, 90)" }}>
                          {shipEquipmentCount.in60DaysCount?.ship ? shipEquipmentCount.in60DaysCount?.ship : 0}&nbsp;
                        </span>
                      </h6>
                    </div>
                    <div className={showEquipmentDetails || editEquipmentDetailsPane ? "col-12" : "col-6"}>
                      <h6 style={{ fontSize: showEquipmentDetails || editEquipmentDetailsPane ? 'small' : '' }} className={`text-nowrap pointer-cursor ${isArabic ? 'arabic' : ''}`} id={isArabic ? (showEquipmentDetails ? 'arabicMobile' : 'arabicId') : ''} onClick={() => this.getShipDetails(6, false, true)}>{t("content.shore")}{" "}
                        <span style={{ color: "rgb(255, 130, 90)" }}>
                          {shipEquipmentCount.in60DaysCount?.shore ? shipEquipmentCount.in60DaysCount?.shore : 0}&nbsp;
                        </span>
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-2">
                <div
                  className={`${isShipsDue90 ? "active " : ""
                    }card card-selector countcard mb2 p-2 text-center pointer-default ${showEquipmentDetails || editEquipmentDetailsPane ? "hei-153" : ''}`}

                >
                  <h3 style={{ color: "rgb(255, 224, 0)" }} className="pointer-cursor" onClick={() => this.getShipDetails(4, false, false)}>
                    {shipEquipmentCount.in90DaysCount?.total
                      ? shipEquipmentCount.in90DaysCount?.total
                      : 0}
                  </h3>
                  {showEquipmentDetails || editEquipmentDetailsPane ? (
                    <h6 className="text-center" style={{ fontSize: "small" }}>{t("ShipEquipmentStatusScreen.Due90")}</h6>
                  ) : (
                    <h6 className="text-center">{t("ShipEquipmentStatusScreen.Due90")}</h6>
                  )}
                  <div className={`row ${showEquipmentDetails || editEquipmentDetailsPane ? "" : "mt-2"}`}>
                    <div className={showEquipmentDetails || editEquipmentDetailsPane ? "col-12" : "col-6"}>
                      <h6 style={{ fontSize: showEquipmentDetails || editEquipmentDetailsPane ? 'small' : '' }} className={`text-nowrap pointer-cursor ${isArabic ? 'arabic' : ''}`} id={isArabic ? (showEquipmentDetails ? 'arabicMobile' : 'arabicId') : ''} onClick={() => this.getShipDetails(4, true, false)} >{t("content.ship")}{" "}
                        <span style={{ color: "rgb(255, 224, 0)" }}>
                          {shipEquipmentCount.in90DaysCount?.ship ? shipEquipmentCount.in90DaysCount?.ship : 0}&nbsp;
                        </span>
                      </h6>
                    </div>
                    <div className={showEquipmentDetails || editEquipmentDetailsPane ? "col-12" : "col-6"}>
                      <h6 style={{ fontSize: showEquipmentDetails || editEquipmentDetailsPane ? 'small' : '' }} className={`text-nowrap pointer-cursor ${isArabic ? 'arabic' : ''}`} id={isArabic ? (showEquipmentDetails ? 'arabicMobile' : 'arabicId') : ''} onClick={() => this.getShipDetails(4, false, true)}>{t("content.shore")}{" "}
                        <span style={{ color: "rgb(255, 224, 0)" }}>
                          {shipEquipmentCount.in90DaysCount?.shore ? shipEquipmentCount.in90DaysCount?.shore : 0}&nbsp;
                        </span>
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        <div className="row mt-2">
          {userrole === Role.mmpladmin ||
            userrole === Role.mmpl ||
            userrole === Role.approver ||
            userrole === Role.client ? (
            <button
              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue m-2 ml-3"
              onClick={() => this.hideSidePanel()}
              style={{ display: 'inline-flex', alignItems: 'center' }}
            >
              <span style={{ marginTop: '-1px' }}>&larr;</span> {t("CommonText.Back")}
            </button>
          ) : (
            <></>
          )}
          <div className="col-lg-12">
            <div className="panel-box">
              <div
                className="card MM-card-header"
                style={{ backgroundColor: "white" }}
              >
                <div className="card-body">
                  <h5
                    className="card-title ml-2 mt-2"
                    style={{ color: "092a51" }}
                  >
                    {t("ShipEquipmentStatusScreen.ShipDetails")}

                  </h5>
                </div>
              </div>
              <div className="py-3">
                <div className="resource-list-auth-date">
                  <div className="row">
                    <div
                      className={
                        userrole === "staff"
                          ? "col-sm-10"
                          : userrole === Role.mmpladmin ||
                            this.state.isGrandAdmin
                            ? "col-sm-10 col-10"
                            : "col-sm-12"
                      }
                    >
                      <div className="row mx-2">
                        <div
                          className={
                            showEquipmentDetails || editEquipmentDetailsPane
                              ? "col-sm-6 mb-2"
                              : "col-sm-3 mb-2"
                          }
                        >
                          <span className={`${isArabic ? 'arabic_ship' : ''}`}>
                            <strong>{t('content.Shipname')} </strong>
                            <strong>:</strong>

                          </span>
                          <span className="lato">
                            {shipDetail.shipName ? shipDetail.shipName : ""}
                          </span>
                        </div>
                        <div
                          className={
                            showEquipmentDetails || editEquipmentDetailsPane
                              ? "col-sm-6 mb-2"
                              : "col-sm-3 mb-2"
                          }
                        >
                          <span className={`${isArabic ? 'arabic' : ''}`}>
                            <strong>{t('content.IMOno')} </strong>
                            <strong>:</strong>
                            <span className="lato">
                              {shipDetail.imoNo ? shipDetail.imoNo : ""}
                            </span>
                          </span>
                        </div>
                        <div
                          className={
                            showEquipmentDetails || editEquipmentDetailsPane
                              ? "col-sm-6 mb-2"
                              : "col-sm-3 mb-2"
                          }
                        >
                          <span>
                            <strong>{t("ShipEquipmentStatusScreen.ShipType")}: </strong>
                            <span className="lato">
                              {shipDetail.typeOfShip
                                ? shipDetail.typeOfShip
                                : ""}
                            </span>
                          </span>
                        </div>
                        <div
                          className={
                            showEquipmentDetails || editEquipmentDetailsPane
                              ? "col-sm-6 mb-2"
                              : "col-sm-3 mb-2"
                          }
                        >
                          <span className={`${isArabic ? 'arabic_ship' : ''}`}>
                            <strong>{t("ShipEquipmentStatusScreen.DateofBuild")} </strong>
                            <strong>:</strong>

                          </span>
                          <span className="lato">
                            {shipDetail.dateOfBuild
                              ? moment(shipDetail.dateOfBuild).format(
                                "DD MMM YYYY"
                              )
                              : ""}
                          </span>
                        </div>
                        <div
                          className={
                            showEquipmentDetails || editEquipmentDetailsPane
                              ? "col-sm-6 mb-2"
                              : "col-sm-3 mb-2"
                          }
                        >
                          <span>
                            <strong>{t("TopPaneContent.Flag")}: </strong>
                            <span className="lato">
                              {shipDetail.flag ? shipDetail.flag : ""}
                            </span>
                          </span>
                        </div>
                        <div
                          className={
                            showEquipmentDetails || editEquipmentDetailsPane
                              ? "col-sm-6 mb-1"
                              : "col-sm-3 mb-2"
                          }
                        >
                          <span>
                            <strong>{t("TopPaneContent.Class")}: </strong>
                            <span className="lato">
                              {shipDetail ? shipDetail.class?.length === 0 ? " " : shipDetail.class?.length > 1 ? shipDetail.class?.map((item) => { return item }).join(',' + " ") : shipDetail.class?.map((i) => i) : ""}
                            </span>
                          </span>
                        </div>
                        <div
                          className={
                            showEquipmentDetails || editEquipmentDetailsPane
                              ? "col-sm-6"
                              : "col-sm-3 mb-2"
                          }
                        >
                          <span>
                            <strong>{t("ShipManagementContent.GRT")}: </strong>
                            <i aria-hidden="true"></i>{" "}
                            <span className="lato">
                              {shipDetail.grt ? shipDetail.grt : ""}
                            </span>
                          </span>
                        </div>
                        <div
                          className={
                            showEquipmentDetails || editEquipmentDetailsPane
                              ? "col-sm-6"
                              : "col-sm-3 mb-2"
                          }
                        >
                          <span className={`${isArabic ? 'arabic' : ''}`}>
                            <strong>{t("ShipManagementContent.DeadWeight")} </strong>
                            <strong>:</strong>
                            <i aria-hidden="true"></i>{" "}
                            <span className="lato">
                              {shipDetail.deadWeight
                                ? shipDetail.deadWeight
                                : ""}
                            </span>
                          </span>
                        </div>
                        <div
                          className={
                            showEquipmentDetails || editEquipmentDetailsPane
                              ? "col-sm-6"
                              : "col-sm-6 mb-2"
                          }
                        >
                          <span className={`${isArabic ? 'arabic_ship' : ''}`}>
                            <strong>{t("EquipmentSeviceDetailsScreen.EnrollmentDate")} </strong>
                            <strong>:</strong>
                            {" "}

                          </span>
                          <span className="lato">
                            {shipDetail.enrollmentDate
                              ? moment(shipDetail.enrollmentDate).format(
                                "DD MMM YYYY"
                              )
                              : ""}

                          </span>
                        </div>
                        <div
                          className={
                            showEquipmentDetails || editEquipmentDetailsPane
                              ? "col-sm-6"
                              : "col-sm-6 mb-2"
                          }
                        >
                          <span>
                            <strong>{t("ShipEquipmentStatusScreen.FirePlan")}: </strong>
                            <span className="italicFont ">
                              {shipDetail.firePlanName}{" "}
                            </span>
                            {shipDetail?.firePlanName ? (
                              <OverlayTrigger
                                placement="bottom"
                                delay={{ show: 250, hide: 400 }}
                                overlay={this.renderfiredownload()}
                              >
                                <i
                                  className="fa fa-download click ml-1"
                                  onClick={() =>
                                    this.DownloadDoc(
                                      shipDetail.firePlanName,
                                      shipDetail.firePlanGUID
                                    )
                                  }
                                  aria-hidden="true"
                                  style={{
                                    color: " #1a3464",
                                    fontSize: "1.2rem",
                                  }}
                                ></i>
                              </OverlayTrigger>
                            ) : (
                              ""
                            )}
                          </span>
                        </div>

                        {localStorage.getItem("UserRoles") === "staff" ? (<></>) :
                          <div
                            className={
                              showEquipmentDetails || editEquipmentDetailsPane
                                ? "col-sm-6"
                                : "col-sm-6 mb-2"}>
                            <span>
                              <strong>{t("ShipEquipmentStatusScreen.ContractAttachment")}: </strong>
                              <span className="italicFont ">
                                {shipDetail?.agreementName}{" "}
                              </span>
                              {shipDetail?.agreementName ? (
                                <>
                                  <OverlayTrigger
                                    placement="bottom"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={this.renderDownloadDetails()}>
                                    <i
                                      className="fa fa-download click ml-1"
                                      onClick={() =>
                                        this.DownloadDoc(
                                          shipDetail?.agreementName,
                                          shipDetail?.agreementGUID)}
                                      aria-hidden="true"
                                      style={{
                                        color: " #1a3464",
                                        fontSize: "1.2rem",
                                      }}
                                    ></i>
                                  </OverlayTrigger>
                                  <OverlayTrigger
                                    placement="bottom"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={this.renderViewDetails()}>
                                    <a
                                      href={shipDetail?.agreementFileUrl}
                                      target="_blank"
                                      className="link-colors pl-2">
                                      <i class="fa fa-eye click ml-2" style={{ fontSize: "1.2rem" }}></i>
                                    </a>
                                  </OverlayTrigger>
                                </>
                              ) : (
                                ""
                              )}
                            </span>
                          </div>}
                        <div
                          className={
                            showEquipmentDetails || editEquipmentDetailsPane
                              ? "col-sm-6" : "col-sm-6 mb-2"}>
                          <span className={`${isArabic ? 'arabic' : ''}`}>
                            <strong>{t("ShipEquipmentStatusScreen.ApproverEmail")}</strong>
                            <strong>:</strong>
                            {/* <i aria-hidden="true"></i>{" "} */}
                            {shipDetail.approver ?
                              <span className="lato">
                                {shipDetail.approver}
                              </span> :
                              <span className="lato ">
                                {t("ShipEquipmentStatusScreen.NotAssigned")}
                              </span>}
                          </span>
                        </div>
                        <div
                          className={
                            showEquipmentDetails || editEquipmentDetailsPane ? "col-sm-6" : "col-sm-6 mb-2"}>
                          <span className={`${isArabic ? 'arabic' : ''}`}>
                            <strong>{t("ShipEquipmentStatusScreen.GrandAdminEmail")}</strong>
                            <strong>: </strong>
                            {/* <i aria-hidden="true"></i>{" "} */}
                            {shipDetail.grantAdmins ?
                              <span className="lato">
                                {shipDetail?.grantAdmins?.map(admin => admin.name).join(', ')}
                              </span> :
                              <span className="lato">
                                {t("ShipEquipmentStatusScreen.NotAssigned")}
                              </span>}
                          </span>
                        </div>

                        {userrole === "staff" ? (
                          <div
                            className={
                              showEquipmentDetails || editEquipmentDetailsPane
                                ? "col-sm-6"
                                : "col-sm-6 mb-2"
                            }>
                            <span>
                              <strong>{t("ShipEquipmentStatusScreen.Title")}: </strong>
                              <i
                                className="fa fa-download click px-1"
                                aria-hidden="true"
                                onClick={() => this.downloadStatus(shipDetail)}
                                style={{ color: " #1a3464", fontSize: "1.5rem" }}
                              ></i>
                            </span>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {(userrole === Role.mmpladmin ||
                      this.state.isGrandAdmin) && (
                        <div className="col-sm-2 mt-2 col-2 align-middle text-center">
                          <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 400 }}
                            overlay={this.renderPopover()}
                          >
                            <a
                              onClick={() => this.ViewNotes(shipDetail)}
                              className="mr-3"
                            >
                              <img width="30" height="30" src={note}></img>
                            </a>
                          </OverlayTrigger>
                        </div>
                      )}

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="panel-box">
              <div
                className="card MM-card-header"
                style={{ backgroundColor: "white" }}
              >
                <div className="card-body">
                  <h5
                    className="card-title ml-2 mt-2"
                    style={{ color: "092a51" }}
                  >
                    {t("ShipEquipmentStatusScreen.Equipment")}
                  </h5>
                </div>
              </div>
              <div className="search-filter-box">
                <div className="row">
                  <div
                    className={
                      showEquipmentDetails || editEquipmentDetailsPane
                        ? "col-lg-6"
                        : "col-lg-4 "
                    }
                  >
                    <div className="autocomplete-wrappers" style={{ 'zIndex': '500' }}>
                      <label className="form-label">{t("ShipEquipmentStatusScreen.Equipment")}</label>
                      <br></br>
                      <Autocomplete
                        contentEditable={true}
                        value={this.state.searchEquipment.equipment}
                        renderInput={(props) => {
                          return (
                            <input
                              className="form-control equipment"
                              id="exampleFormControlInput1"
                              {...props}
                            />
                          );
                        }}
                        inputProps={{ placeholder: `${t("ShipEquipmentStatusScreen.Equipment")}` }}
                        items={EquipmentNameList ?? []}
                        getItemValue={(item) => item.equipmentName}
                        shouldItemRender={this.renderEquipmentTitle.bind(this)}
                        renderMenu={(item) => (
                          <div className="dropdown">{item}</div>
                        )}
                        renderItem={(item, isHighlighted) => (
                          <div
                            className={`items ${isHighlighted ? "selected-items" : ""
                              }`}
                          >
                            {item.equipmentName}
                          </div>
                        )}
                        onChange={(e) =>
                          this.handleInputChanges(
                            e,
                            "equipment",
                            "EquipmentName"
                          )
                        }
                        onSelect={(value, item) =>
                          this.handleSelectChange(
                            value,
                            "equipment",
                            item.equipmentId,
                            "EquipmentName"
                          )
                        }
                      />
                    </div>
                  </div>
                  <div
                    className={
                      showEquipmentDetails || editEquipmentDetailsPane
                        ? "col-lg-6"
                        : "col-lg-4 "
                    }
                  >
                    <div className="autocomplete-wrappers">
                      <label className="form-label">{t("TopPaneContent.Category")}</label>
                      <br></br>
                      {/* <div> */}
                      <Autocomplete
                        contentEditable={true}
                        value={this.state.searchEquipment.category}
                        renderInput={(props) => {
                          return (
                            <input
                              className="form-control equipment"
                              id="exampleFormControlInput1"
                              {...props}
                            />
                          );
                        }}
                        inputProps={{ placeholder: `${t("TopPaneContent.Category")}` }}
                        items={CategoryNameList ?? []}
                        getItemValue={(item) => item.category}
                        // shouldItemRender={this.renderCategoryTitle.bind(this)}
                        renderMenu={(item) => (
                          <div className="dropdown">{item}</div>
                        )}
                        renderItem={(item, isHighlighted) => (
                          <div
                            className={`items ${isHighlighted ? "selected-items" : ""
                              }`}
                          >
                            {item.category}
                            {/* &nbsp; ({(item.category && (item.capacity || item.equipmentType)) ? item.category + "," : item.category ? item.category : ""}&nbsp; {(item.capacity && (item.category || item.equipmentType)) ? item.capacity + "," : item.capacity ? item.capacity : ""}&nbsp; {item.equipmentType ? item.equipmentType : ""}) */}
                          </div>
                        )}
                        onChange={(e) =>
                          this.handleInputChanges(e, "category", "Category")
                        }
                        onSelect={(value, item) =>
                          this.handleSelectChange(
                            value,
                            "category",
                            item.equipmentId,
                            "Category"
                          )
                        }
                      />
                    </div>
                  </div>
                  <div
                    className={
                      showEquipmentDetails || editEquipmentDetailsPane
                        ? "col-lg-6"
                        : "col-lg-4 "
                    }
                    style={{}}
                  >
                    <label className="form-label">{t("content.Servicetype")}</label>
                    <Multiselect
                      ref={this.multiSelectRef}
                      options={serviceTypeList ?? []}
                      showArrow={true}
                      isObject={false}
                      style={{
                        option: {
                          marginRight: 0,
                          display: "block",
                          fontWeight: "normal",
                        },
                        chips: { backgroundColor: "#1a3464" },
                      }}
                      onSelect={(item) => this.onSelectChange(item)}
                      onRemove={(item) => this.onRemoveChange(item)}
                      selectedValues={this.state.searchEquipment.ServiceTypes}
                      placeholder={
                        this.state.searchEquipment.ServiceTypes &&
                          this.state.searchEquipment.ServiceTypes.length
                          ? ""
                          : `${t("content.Select")}`
                      }
                      closeIcon="cancel"
                      value={this.state.searchEquipment.ServiceTypes}
                    />
                    {/* <div className="row">
                      <div className={showEquipmentDetails ? "row ml-0" : "col-sm-12 flex flexwrap"}>
                        <div className={showEquipmentDetails ? "col-sm-6" : ""}>
                          <input type="checkbox" checked={serviceType.length != 0 ? (serviceType.filter(e => e.checkboxValue == 'Annual').length != 0 ? true : false) : false} onChange={this.checkBoxClick.bind(this, 'Annual')}></input>
                          <span className="ml-1">Annual</span>
                        </div>
                        <div className={showEquipmentDetails ? "col-sm-6" : ""}>
                          <input type="checkbox" checked={serviceType.length != 0 ? (serviceType.filter(e => e.checkboxValue == 'Biannual').length != 0 ? true : false) : false} onChange={this.checkBoxClick.bind(this, 'Biannual')}></input>
                          <span className="ml-1">Biannual</span>
                        </div>
                        <div className={showEquipmentDetails ? "col-sm-6" : ""}>
                          <input type="checkbox" checked={serviceType.length != 0 ? (serviceType.filter(e => e.checkboxValue == 'Five yearly').length != 0 ? true : false) : false} onChange={this.checkBoxClick.bind(this, 'Five yearly')}></input>
                          <span className="ml-1">Five Yearly</span>
                        </div>
                        <div className={showEquipmentDetails ? "col-sm-6" : ""}>
                          <input type="checkbox" checked={serviceType.length != 0 ? (serviceType.filter(e => e.checkboxValue == 'Ten yearly').length != 0 ? true : false) : false} onChange={this.checkBoxClick.bind(this, 'Ten yearly')}></input>
                          <span className="ml-1">Ten Yearly</span>
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="row ">
                      <div className={showEquipmentDetails?"col-sm-6":"col-sm-3 col6"}>
                        <input type="checkbox" checked={serviceType.length != 0 ? (serviceType.filter(e => e.checkboxValue == 'Annual').length != 0 ? true : false) : false} onChange={this.checkBoxClick.bind(this, 'Annual')}></input>
                        <span className="ml-1" >Annual</span>
                      </div>
                      <div className={showEquipmentDetails?"col-sm-6":"col-sm-3 col6"}>
                        <input type="checkbox" checked={serviceType.length != 0 ? (serviceType.filter(e => e.checkboxValue == 'Biannual').length != 0 ? true : false) : false} onChange={this.checkBoxClick.bind(this, 'Biannual')}></input>
                        <span className="ml-1">Biannual</span>
                      </div>
                      <div className={showEquipmentDetails?"col-sm-6":"col-sm-3 col6"}>
                        <input type="checkbox" checked={serviceType.length != 0 ? (serviceType.filter(e => e.checkboxValue == 'Five yearly').length != 0 ? true : false) : false} onChange={this.checkBoxClick.bind(this, 'Five yearly')}></input>
                        <span className="ml-1" >Five Yearly</span>
                      </div>
                      <div className={showEquipmentDetails?"col-sm-6":"col-sm-3 col6"}>
                        <input type="checkbox" checked={serviceType.length != 0 ? (serviceType.filter(e => e.checkboxValue == 'Ten yearly').length != 0 ? true : false) : false} onChange={this.checkBoxClick.bind(this, 'Ten yearly')}></input>
                        <span className="ml-1">Ten Yearly</span>
                      </div>
                    </div> */}
                  </div>
                  <div
                    className={
                      showEquipmentDetails || editEquipmentDetailsPane
                        ? "col-lg-12"
                        : "col-lg-4  col-sm-12 col-xs-12"
                    }
                  >
                    <div className="row">
                      <div
                        className={
                          showEquipmentDetails || editEquipmentDetailsPane
                            ? "col-lg-6"
                            : "col-lg-6"
                        }
                      >
                        <label className="form-label">{t("content.NextDueFrom")}</label>
                        <div
                          className="input-group add-on date datepicker datezindex"
                          data-date-format="yyyy-mm-dd"
                        >
                          <input
                            type="text"
                            value={this.state.searchEquipment.next_due_in_from}
                            className="form-control date-picker"
                            placeholder={t("content.NextDueFrom")}
                            name="fromDate"
                          ></input>
                          <DatePicker
                            selected={this.state.SelectedFromDate}
                            onChange={this.handleFromDateChange}
                            open={this.state.fromDatePickerIsOpen}
                            onClickOutside={this.handleBlur}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control date-picker w-5 hide-date calendar-popup"
                          />
                          <div
                            className="input-group-btn calendar-icon"
                            onClick={this.openFromDatePicker}
                          >
                            <button className="btn btn-default">
                              <i className="fa fa-calendar mt-1"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        className={
                          showEquipmentDetails || editEquipmentDetailsPane
                            ? "col-lg-6"
                            : "col-lg-6"
                        }
                      >
                        <label className="form-label">{t("content.NextDueTo")}</label>
                        <div
                          className="input-group add-on date datepicker datezindex"
                          data-date-format="yyyy-mm-dd"
                        >
                          <input
                            value={this.state.searchEquipment.next_due_in_to}
                            type="text"
                            placeholder={t("content.NextDueTo")}
                            className="form-control date-picker"
                            name="toDate"
                            data-date-format="yyyy-mm-dd"
                          />
                          <DatePicker
                            selected={this.state.SelectedToDate}
                            onChange={this.handleToDateChange}
                            open={this.state.toDatePickerIsOpen}
                            onClickOutside={this.handleBlur}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control date-picker w-5 hide-date"
                          />
                          <div className="input-group-btn calendar-icon">
                            <button
                              className="btn btn-default"
                              onClick={this.openToDatePicker}
                            >
                              <i className="fa fa-calendar mt-1"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div
                    className={
                      showEquipmentDetails || editEquipmentDetailsPane
                        ? "col-sm-12 mt-4"
                        : "col-lg-12 mt-4"
                    }
                  >
                    <div
                      className="form-group search-btn-col"
                      style={{ textAlign: "end" }}
                    >
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                        type="submit"
                        onClick={() => this.SearchEquipmentData(1)}
                      >
                        {" "}
                        {t("content.Search")}{" "}
                      </button>

                      <button
                        className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                        type="button"
                        onClick={() => this.ClearShipSearchField()}
                      >
                        {" "}
                        {t("content.Clear")}{" "}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*   <div className="row">
          <div className="col-lg-12">
            <div className="panel-box">
              <Accordion>
                <Card
                  className={"MM-card-header"}
                  style={{ backgroundColor: "white" }}
                >
                  <Accordion.Toggle
                    as={Card.Body}
                    eventKey="0"
                    style={{ cursor: "pointer" }}
                    onClick={this.toggleVisibiliti}
                  >
                    <h5
                      className="card-title ml-2 mt-2"
                      style={{ color: "092a51" }}
                    >
                      {!this.state.isFile ? (
                        <i
                          className="fa fa-plus mr-1"
                          aria-hidden="true"
                          style={{ color: "#fff", fontSize: "1.1rem" }}
                        ></i>
                      ) : (
                        <i
                          className="fa fa-minus mr-1"
                          aria-hidden="true"
                          style={{ color: "#fff", fontSize: "1.1rem" }}
                        ></i>
                      )}{" "}
                      Graph View
                    </h5>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="0">
                    <div
                      class="chartWrapper"
                      style={
                        window.innerWidth < 1000 || this.state.scroll == true
                          ? { overflowX: "scroll" }
                          : { overflowX: "hidden" }
                      }
                    >
                      <div
                        className="chartAreaWrapper"
                        style={
                          window.innerWidth < 1000 || this.state.scroll == true
                            ? {}
                            : { width: "100%" }
                        }
                      >
                        <Bar height={150} options={options} data={data} />
                      </div>
                    </div>
                  </Accordion.Collapse>
                </Card>
              </Accordion>
            </div>
          </div>
        </div> */}

        {shipSearchResult ? (
          <EquipmentCard
            currentPage={(shipSearchResult.pagination.currentPage - 1) * shipSearchResult.pagination.pageSize}
            arraylist={shipSearchResult.data}
            pageSize={shipSearchResult.pagination.pageSize}
            totalRecords={
              shipSearchResult.pagination.totalcount
                ? shipSearchResult.pagination.totalcount
                : 0
            }
            setUpdatedState={(value) => this.SearchEquipmentData(value)}
            shipId={this.state.searchEquipment.shipId}
          />
        ) : null}
      </div>
    );
  }
  DownloadDoc(firePlanName, firePlanGUID) {
    this.props.dispatch(DownloadFirePlanAttachment(firePlanName, firePlanGUID));
  }
}

function mapStateToProps(state) {
  return {
    arraylist: state.SidePanReducer.arraylist,
    materialDeclarationslist: state.SidePanReducer.arraylist,
    MDDeleteSuccess: state.SidePanReducer.MDDeleteSuccess,
    isMDSearch: state.SidePanReducer.isMDSearch,
    MDSearchData: state.SidePanReducer.MDSearchData,
    showSidePane: state.SidePanReducer.sidePan || false,
    //BY BALU MOORTHI
    shipEquipmentCount: state.ShipEquipmentReducer.ShipEquipmentCount || {
      ClientId: 0,
      total: 0,
      overDue: 0,
      in30Days: 0,
      in90Days: 0,
    },
    shipDetail: state.ShipEquipmentReducer.ShipDetail || {},
    shipSearchResult: state.ShipEquipmentReducer.shipSearchResult,
    showEquipmentDetails: state.SidePanReducer.ShowEquipmentDetails || false,
    editShipDetailsPane: state.SidePanReducer.EditShipDetails || false,
    editEquipmentDetailsPane:
      state.SidePanReducer.EditEquipmentDetails || false,
    serviceTypeList:
      state.MasterScreenReducer.applicableServiceTypeInterval || [],
    EquipmentNameList: state.MasterScreenReducer.EquipmentNameList1 || [],
    CategoryNameList: state.MasterScreenReducer.CategoryNameList || [],
    IsServiceUpdate: state.ServiceUpdateReducer.IsServiceUpdate,
    EditShipDetails: state.SidePanReducer.EditShipDetails
    // serviceTypeList: state.SidePanReducer.ServiceTypeList || {},
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(ShipLibrary));
